"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_hooks_1 = require("@apollo/react-hooks");
const graphql_1 = require("../../graphql");
exports.useCreateEmailTemplateVersion = ({ emailTemplateId, html, version, }) => {
    const [mutate, result] = react_hooks_1.useMutation(graphql_1.createEmailTemplateVersion, {
        variables: {
            data: {
                codePulledFrom: 'emailEditor',
                emailTemplateId,
                html,
                releaseNotes: '{}',
                url: '',
                version,
            },
        },
    });
    return { mutate, result };
};
//# sourceMappingURL=useCreateEmailTemplateVersion.js.map